if (!customElements.get('video-full-width')) {
    class VideoFullWidth extends HTMLElement {
        constructor() {
            super();
            this.video = this.querySelector('video');
            this.iframe = this.querySelector('.youtube-player-class');
            this.button = this.querySelector('.video-full-width-overlay');
            this.overlay = this.querySelector('.video-full-width-content');
            this.youtubeId = this.getAttribute('data-youtube-video-id');
            this.player = null; // 用于保存播放器实例
        }

        connectedCallback() {
            // var tag = document.createElement('script');
            // tag.src = "https://www.youtube.com/iframe_api";
            // document.body.appendChild(tag); // 安全地将 script 标签插入 body
            // window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this); // 绑定上下文
            this.videoPlay();
        }

        videoPlay() {
            if (this.button) {
                this.button.addEventListener('click', () => {
                    if (this.video) {
                        this.video.setAttribute('controls', 'controls');
                        this.video.play();
                    } else if (this.iframe) {
                        this.initializeYouTubePlayer(); // 初始化 YouTube 播放器
                    }
                    this.showAndHideOverlay();
                    this.hideButton();
                });
            }
        }

        // 初始化 YouTube 播放器
        initializeYouTubePlayer() {
            if (this.player === null) {
                this.player = new YT.Player(this.iframe, {
                    height: '360',
                    width: '640',
                    videoId: this.youtubeId,
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': this.onPlayerStateChange.bind(this)
                    }
                });

                function onPlayerReady(event) {
                    console.log("Player is ready");
                    // console.log(event.target);
                    event.target.playVideo();
                }
            }
        }

        onYouTubeIframeAPIReady() {
            // 此处会在 YouTube IFrame API 加载完毕时被调用
            if (this.iframe) {
                this.initializeYouTubePlayer(); // 初始化播放器
            }
        }

        onPlayerStateChange(event) {
            // 处理播放器状态改变的逻辑
            if (event.data == YT.PlayerState.ENDED) {
                console.log("Video ended");
            }
        }

        showAndHideOverlay() {
            if (this.overlay) {
                this.overlay.classList.toggle('active');
            }
        }

        hideButton() {
            if (this.button) {
                this.button.style.display = 'none';
            }
        }
    }

    customElements.define('video-full-width', VideoFullWidth);
}
